export function Header() {
  return (
    <header style={{
      padding: 'var(--space-lg)',
      borderBottom: '1px solid var(--border)',
    }}>
      <div className="container" style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 'var(--space-sm)',
        padding: 0,
      }}>
        <svg 
          width="32" 
          height="32" 
          viewBox="0 0 64 64" 
          fill="none"
          style={{ flexShrink: 0 }}
        >
          {/* Carbon logo - two Cs forming a circle */}
          <rect x="4" y="4" width="56" height="56" rx="14" fill="#18181B"/>
          <path
            d="M 46 32 A 14 14 0 0 0 18 32"
            fill="none"
            stroke="#38BDF8"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M 18 32 A 14 14 0 0 0 46 32"
            fill="none"
            stroke="#FFFFFF"
            strokeWidth="5"
            strokeLinecap="round"
          />
        </svg>
        <span style={{
          fontSize: '18px',
          fontWeight: 600,
          color: 'var(--text)',
        }}>
          Carbon
        </span>
      </div>
    </header>
  )
}
